var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5625 10.0566H20.4371C24.9358 10.0566 27.1865 10.0566 28.4505 11.3726C29.7131 12.6886 29.4158 14.7206 28.8211 18.786L28.2585 22.642C27.7918 25.83 27.5585 27.4246 26.3625 28.3793C25.1665 29.334 23.4025 29.334 19.8731 29.334H12.1265C8.59845 29.334 6.83312 29.334 5.63712 28.3793C4.44112 27.4246 4.20779 25.83 3.74112 22.642L3.17845 18.786C2.58245 14.7206 2.28512 12.6886 3.54912 11.3726C4.81312 10.0566 7.06379 10.0566 11.5625 10.0566ZM10.6665 24.0006C10.6665 23.4486 11.1638 23.0006 11.7771 23.0006H20.2225C20.8358 23.0006 21.3331 23.4486 21.3331 24.0006C21.3331 24.5526 20.8358 25.0006 20.2225 25.0006H11.7771C11.1638 25.0006 10.6665 24.5526 10.6665 24.0006Z",
    fill: "#6F6F67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.3453 2.66602H20.652C20.9626 2.66602 21.1986 2.66602 21.408 2.68602C22.8853 2.83135 24.0933 3.71935 24.6066 4.91535H7.39062C7.90396 3.71935 9.11329 2.83135 10.5906 2.68602C10.7973 2.66602 11.036 2.66602 11.3453 2.66602Z",
    fill: "#6F6F67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M8.412 6.29492C6.55867 6.29492 5.03867 7.41492 4.532 8.89892C4.5209 8.92988 4.51023 8.96099 4.5 8.99225C5.03743 8.83515 5.58682 8.72233 6.14267 8.65492C7.58267 8.47092 9.404 8.47092 11.5187 8.47092H20.708C22.8227 8.47092 24.644 8.47092 26.084 8.65492C26.644 8.72692 27.196 8.83225 27.7267 8.99225C27.7169 8.96101 27.7066 8.9299 27.696 8.89892C27.1893 7.41359 25.6693 6.29492 23.8147 6.29492H8.412Z",
    fill: "#6F6F67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/media-icon.a666ed179169e9f9d69543ba89b73a61.svg";
export { ForwardRef as ReactComponent };